import { render, staticRenderFns } from "./guide-pin-chats.vue?vue&type=template&id=cf0e51ba"
import script from "./guide-pin-chats.vue?vue&type=script&lang=js"
export * from "./guide-pin-chats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports